module.exports = __webpack_public_path__ + "img/38.1d99c8a1.png";